import { render, staticRenderFns } from "./GalleryPhotoPreview.vue?vue&type=template&id=b9ae2c34&scoped=true&"
import script from "./GalleryPhotoPreview.vue?vue&type=script&lang=js&"
export * from "./GalleryPhotoPreview.vue?vue&type=script&lang=js&"
import style0 from "./GalleryPhotoPreview.vue?vue&type=style&index=0&id=b9ae2c34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ae2c34",
  null
  
)

export default component.exports